import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Cpu } from "lucide-react";

const Loader = () => (
  <div className="min-h-screen grid place-items-center bg-ink-base">
    <div className="w-12 h-12 grid place-items-center border border-aurora-cyan/40 rounded-sm bg-aurora-cyan/10 animate-pulse-glow">
      <Cpu className="w-6 h-6 text-aurora-cyan" />
    </div>
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/client" replace />;
  return children;
};
